import { createDraftOrder } from "../api/methods";
import { ACTIONSMAPPINGTYPES, SECTIONSTATES } from "../common/constants";
import { ClickStreamEventActions } from "../native/constants";
import {
	processAPI,
	processRedirection,
	processAttributeHandler,
	processFilterHandler,
	processCollapseNext,
	processSectionActionLabel,
} from "./api";
import { formProcessor, analyticsProcessor } from "./onLoad";
import { getDraftOrderBody } from "./utility";

/* fix it later  */
const doNotExecuteNormallyApiId = {
	kycdigiLockerFileList: "kycdigiLockerFileList",
};

const handleActionsMapping = async (entity) => {
	let response = "";
	if (entity.actionsMapping && entity.actionsMapping?.type) {
		switch (entity.actionsMapping.type) {
			case ACTIONSMAPPINGTYPES.API: {
				if (entity?.actionsMapping?.apiInfo?.id in doNotExecuteNormallyApiId)
					break;
				response = await processAPI(entity.actionsMapping.apiInfo, entity.fieldData);
				response?.body && response?.body.sectionActionLabel && processSectionActionLabel(response.body.sectionActionLabel);
				return response;
			}
			case ACTIONSMAPPINGTYPES.API_REDIRECTION: {
				const response = await processAPI(entity.actionsMapping.apiInfo, entity.fieldData);
				if (response?.body) {
					await processRedirection(entity.actionsMapping.redirectionInfo, entity);
				}
				return response;
			}
			case ACTIONSMAPPINGTYPES.REDIRECTION: {
				await processRedirection(entity.actionsMapping.redirectionInfo, entity);
				break;
			}
			case ACTIONSMAPPINGTYPES.FILTER_HANDLER: {
				await processFilterHandler(entity);
				break;
			}
			case ACTIONSMAPPINGTYPES.ATTRIBUTE_HANDLER: {
				await processAttributeHandler(entity);
				break;
			}
			case ACTIONSMAPPINGTYPES.COLLAPSE_NEXT: {
				await processCollapseNext();
				break;
			}
			case ACTIONSMAPPINGTYPES.MODAL: {
				handleModal(entity);
				break;
			}
			case ACTIONSMAPPINGTYPES.ATTRIBUTE_HANDLER_MODAL: {
				await processAttributeHandler(entity);
				handleModal(entity);
				break;
			}
			case ACTIONSMAPPINGTYPES.API_COLLAPSE_NEXT: {
				const response = await processAPI(
					entity.actionsMapping.apiInfo,
					entity.fieldData
				);
				if (response?.body) {
					await processCollapseNext();
				}
				return response;
			}
			case ACTIONSMAPPINGTYPES.CUSTOM_REDIRECTION_SKYC: {
				const response = await processAPI(
					entity.actionsMapping.apiInfo,
					entity.fieldData
				);
				if (response?.body) {
					const body = getDraftOrderBody();
					await createDraftOrder(body);
					await processRedirection(
						entity.actionsMapping.redirectionInfo,
						entity
					);
				}
				return response;
			}
			case ACTIONSMAPPINGTYPES.CLOSE_MODAL: {
				closeModal(entity);
				break;
			}
		}
	}
	return response;
};

const handleCommonErrorModal = (errorInfo) => {
	formProcessor.changeSectionState("KycCommonErrorModal", SECTIONSTATES.OPEN, errorInfo);
};

const handleModal = (entity) => {
	const sectionId = entity.actionsMapping?.navigateTo;
	formProcessor.changeSectionState(sectionId, SECTIONSTATES.OPEN);
};

const closeModal = (entity) => {
	const sectionId = entity.fieldData.sectionId;
	formProcessor.changeSectionState(sectionId, SECTIONSTATES.CLOSE);
};

const onLoadAction = async (fieldData, actionsMapping) => {
	if (actionsMapping && actionsMapping?.onLoad) {
		await handleActionsMapping({
			fieldData: fieldData,
			actionsMapping: actionsMapping?.onLoad,
		});
	}
};

const onChangeAction = async (
	fieldData,
	actionsMapping,
	entity = undefined
) => {
	if (actionsMapping && fieldData?.actionsMapping?.onChange) {
		await handleActionsMapping({
			currentField: entity,
			fieldData: fieldData,
			actionsMapping: actionsMapping?.onChange,
		});
	}
};

const onClickAction = async (fieldData, actionsMapping, entity = undefined) => {
	if (actionsMapping && actionsMapping?.onClick) {
		return await handleActionsMapping({
			currentField: entity,
			fieldData: fieldData,
			actionsMapping: actionsMapping?.onClick,
		});
	}
};

const onCompleteAction = async (
	fieldData,
	actionsMapping,
	entity = undefined
) => {
	if (actionsMapping && actionsMapping?.onComplete) {
		await handleActionsMapping({
			currentField: entity,
			fieldData: fieldData,
			actionsMapping: actionsMapping?.onComplete,
		});
	}
};

const onButtonClickStreamCapture = (fieldData) => {
	analyticsProcessor.captureAnalytics({
		fieldData: fieldData,
		fieldId: fieldData.fieldId,
		sectionId: fieldData.sectionId,
		metric: {
			action: ClickStreamEventActions.click,
			subSection: fieldData?.attributes?.analytics?.subSection,
			eventLabel: fieldData?.attributes?.analytics?.eventLabel,
			eventValue: "",
		},
	});
};

const onActionLabelClickStreamCapture = (fieldData, actionLabel) => {
	analyticsProcessor.captureAnalytics({
		fieldData: fieldData,
		fieldId: fieldData.fieldId,
		sectionId: fieldData.sectionId,
		metric: {
			action: ClickStreamEventActions.click,
			subSection: actionLabel?.subSection,
			eventLabel: actionLabel?.eventLabel,
		},
	});
};

const checkIfApiInfoPresent = (actionsMapping) => {
	try {
		const plainString = JSON.stringify(actionsMapping);
		if (plainString.indexOf("guardian")) return true;
	}
	catch (err) {
		console.log(`JSON Stringify exception ${err}`)
	}
	return false;
}

export {
	handleActionsMapping,
	onLoadAction,
	onChangeAction,
	onClickAction,
	onCompleteAction,
	onButtonClickStreamCapture,
	onActionLabelClickStreamCapture,
	handleCommonErrorModal,
	checkIfApiInfoPresent
};
